/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const postProjectsProjectidPreferencesUnitsPathProjectIdSchema = z.string()

export const postProjectsProjectidPreferencesUnitsStatus201Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const postProjectsProjectidPreferencesUnitsStatus400Schema = z.string()

export const postProjectsProjectidPreferencesUnitsStatus401Schema = z.string()

export const postProjectsProjectidPreferencesUnitsStatus409Schema = z.string()

export const postProjectsProjectidPreferencesUnitsStatus500Schema = z.string()

export const postProjectsProjectidPreferencesUnitsResponseSchema = postProjectsProjectidPreferencesUnitsStatus201Schema

export const postProjectsProjectidPreferencesUnitsErrorSchema = z.union([postProjectsProjectidPreferencesUnitsStatus400Schema, postProjectsProjectidPreferencesUnitsStatus401Schema, postProjectsProjectidPreferencesUnitsStatus409Schema, postProjectsProjectidPreferencesUnitsStatus500Schema])

export const postProjectsProjectidPreferencesUnitsBodySchema = z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
}).optional()
